<template>
  <div>

    <div style="font-size: 50px;font-weight: bold">
      {{departmentInfo.department_name}}
    </div>

    <div style="font-size: 20px;font-weight: bold">
      {{departmentInfo.intro}}
    </div>

    <div class='sc-list' >

      <div  class="sc-item" v-for="(item,index) in movieList" :key="index">

        <MovieItem :data="item"></MovieItem>
      </div>

    </div>

  </div>
</template>

<script>
import {getMovieDepartmentDetail} from '../../../../request/api'
import MovieItem from './MovieItem'

export default {
  name: 'MovieDepartmentInfo',
  components: {MovieItem},
  data () {
    return {
      departmentInfo: '',
      movieList: []
    }
  },
  methods: {
    init () {
      var params = {'department_id': this.$route.query.department_id}

      getMovieDepartmentDetail(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.departmentInfo = res.data

          this.movieList = res.data.movies
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>
.sc-item{
  text-align: center;
  /*float: left;*/

  margin-top:20px;
  margin-bottom:20px;
  /*margin: 20px auto;*/

}
.sc-list{
  flex-wrap: wrap;
  /*margin-left:@lrwith;*/
  /*margin-right:@lrwith;*/
  display: flex;
  justify-content: space-around;
  /* !主轴水平时!决定了item在交叉轴上的对齐方式，可能的值有flex-start|flex-end|center|baseline|stretch */
  /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MovieDepartmentInfo.vue